// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__210ym","detailsBorder":"styles_detailsBorder__2ddHM"};